import React, { useEffect, useState } from "react";
import axios from "axios";
import "./HomeHeader.css";

const BASE_URL = "https://kkblossomschool.org/KKBlossomsWebsite/api.php";
const UPLOADS_URL = "https://kkblossomschool.org/KKBlossomsWebsite/uploads";

function HomeHeader() {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    fetchBanner();
  }, []);
const [loading, setLoading] = useState(true);
 const fetchBanner = async () => {
  try {
    setLoading(true); // start loader

    const res = await axios.get(
      `${BASE_URL}?action=getHomeBanner`
    );

    console.log("API Response:", res.data);

    if (res.data.status === "success") {
      setBanner(res.data.banner);
    } else {
      setBanner(null);
    }

  } catch (err) {
    console.log(err);
    setBanner(null);
  } finally {
    setLoading(false); // stop loader
  }
};

  const imageUrl = banner
    ? `${UPLOADS_URL}/${banner.image}`
    : "";

  console.log("Banner:", banner);
  console.log("Image Name:", banner?.image);
  console.log("Image URL:", imageUrl);
if (loading) {
  return (
   <div className="awards-loader-wrapper">
        <svg
          role="img"
          aria-label="Loading"
          className="awards-smiley"
          viewBox="0 0 128 128"
        >
          <defs>
            <clipPath id="awards-smiley-eyes">
              <circle
                className="awards-smiley__eye1"
                cx="64"
                cy="64"
                r="8"
                transform="rotate(-40,64,64) translate(0,-56)"
              />
              <circle
                className="awards-smiley__eye2"
                cx="64"
                cy="64"
                r="8"
                transform="rotate(40,64,64) translate(0,-56)"
              />
            </clipPath>

            <linearGradient
              id="awards-smiley-grad"
              x1="0"
              y1="0"
              x2="0"
              y2="1"
            >
              <stop offset="0%" stopColor="#000" />
              <stop offset="100%" stopColor="#fff" />
            </linearGradient>

            <mask id="awards-smiley-mask">
              <rect
                x="0"
                y="0"
                width="128"
                height="128"
                fill="url(#awards-smiley-grad)"
              />
            </mask>
          </defs>

          <g
            strokeLinecap="round"
            strokeWidth="12"
            strokeDasharray="175.93 351.86"
          >
            <g>
              <rect
                fill="hsl(207, 90%, 50%)"
                width="128"
                height="64"
                clipPath="url(#awards-smiley-eyes)"
              />

              <g fill="none" stroke="hsl(198, 83%, 60%)">
                <circle
                  className="awards-smiley__mouth1"
                  cx="64"
                  cy="64"
                  r="56"
                  transform="rotate(180,64,64)"
                />

                <circle
                  className="awards-smiley__mouth2"
                  cx="64"
                  cy="64"
                  r="56"
                />
              </g>
            </g>

            <g mask="url(#awards-smiley-mask)">
              <rect
                fill="hsl(205, 86%, 62%)"
                width="128"
                height="64"
                clipPath="url(#awards-smiley-eyes)"
              />

              <g fill="none" stroke="hsl(197, 94%, 63%)">
                <circle
                  className="awards-smiley__mouth1"
                  cx="64"
                  cy="64"
                  r="56"
                  transform="rotate(180,64,64)"
                />

                <circle
                  className="awards-smiley__mouth2"
                  cx="64"
                  cy="64"
                  r="56"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
  );
}
  return (
    
    <div
    
      className="banner-serction jumbotron-fluid position-relative overlay-bottom"
      style={{
        height: "100vh",
        backgroundImage: banner
          ? `linear-gradient(rgba(104,161,241,.95), rgba(93,135,194,.40)), url("${imageUrl}")`
          : `linear-gradient(rgba(104,161,241,.95), rgba(93,135,194,.40))`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        marginBottom: "60px",
      }}
    >
      <div
        className="text-center"
        style={{
          position: "absolute",
          top: "40%",
          right: "0",
          padding: "0 56px",
        }}
      >
        <h1
          className="text-white"
          style={{
            fontSize: "60px",
          }}
        >
          {banner?.heading}
        </h1>

        <p className="home-desc">
          {banner?.description}
        </p>

        {/* Debug */}
        {/* {banner && (
          <>
            <p style={{ color: "white" }}>
              {banner.image}
            </p>

            <img
              src={imageUrl}
              alt="banner"
              width="300"
              onLoad={() => console.log("Image Loaded")}
              onError={() => console.log("Image Failed")}
            />
          </>
        )} */}
      </div>
    </div>
  );
}

export default HomeHeader;